@if (label) {
  <label>{{ label | transloco }}</label>
}

<nz-date-picker
  [(ngModel)]="internalValue"
  [disabled]="disabled"
  [nzDisabledDate]="disableDateFn"
  [nzMode]="mode"
  [nzPlaceHolder]="placeholder | transloco"
  (blur)="syncExternalTouched()"
  (ngModelChange)="onModelChange($event)"></nz-date-picker>
